import { graphql } from "@/graphql/generated/gql";

export const getProjectListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetProjectListForWorkspace($input: GetProjectListForWorkspaceInput!) {
    projectListForWorkspace(getProjectListForWorkspaceInput: $input) {
      ...ProjectFields
    }
  }
`);

export const getProjectQueryDocument = graphql(/* GraphQL */ `
  query GetProject($input: GetProjectInput!) {
    project(getProjectInput: $input) {
      ...ProjectFields
    }
  }
`);

export const createProjectMutationDocument = graphql(/* GraphQL */ `
  mutation createProject($input: CreateProjectInput!) {
    createProject(createProjectInput: $input) {
      ...ProjectFields
    }
  }
`);

export const updateProjectMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(updateProjectInput: $input) {
      ...ProjectFields
    }
  }
`);

export const getSharedProjectListForTeamQueryDocument = graphql(/* GraphQL */ `
  query GetSharedProjectListForTeam($input: SharedEntityListForTeamInput!) {
    sharedProjectListForTeam(input: $input) {
      ...ProjectFields
    }
  }
`);

export const deleteProjectMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteProject($input: DeleteProjectInput!) {
    deleteProject(deleteProjectInput: $input) {
      id
      title
      properties
      description
      workspaceId
      createdAt
      updatedAt
    }
  }
`);
